import {
  getConsolidationSelectionTotals,
  getConsolidationTotals
} from '../utils/utils';

export const getCopperInternetConsolidationTotals = copperInternetData => {
  return getConsolidationTotals(copperInternetData);
};

export const getCopperInternetConsolidationPriceSelections = copperInternetData => {
  return getConsolidationSelectionTotals(
    copperInternetData,
    'copperInternetData'
  );
};
